export default {
    /**
     * chưa gửi
     */
    NotSentYet: 0,
    /**
     * đã gửi
     */
    Sent: 1
}